import { Getters } from 'vuex-smart-module';
import { PaymentMethods, PaymentMethodsTranslate } from '@/enums';
import { SelectItem } from '@/types';
import DispatchesState from './state';
import { Dispatches } from '../types';

export default class DispatchesGetters extends Getters<DispatchesState> {

}
